import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SupportModalComponent } from './support-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { WordingModule } from '../../pipes';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { SupportModalService } from './support-modal.service';
import { MatCardModule as MatCardModule } from '@angular/material/card';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonLauncherReadSpeakerModule } from '../read-speaker';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    WordingModule,
    MatButtonModule,
    MatDialogModule,
    MatCardModule,
    ButtonLauncherReadSpeakerModule,
    SupportModalComponent,
  ],
  providers: [SupportModalService],
})
export class SupportModalModule {}
